export const BASE_URLS = [
  'https://descopecdn.com',
  'https://static.descope.com',
  'https://cdn.jsdelivr.net',
];
